import { SDKResource } from '../../client/client.js';
import { search, create, get, update, patch, delete as del, history, batch, transaction, formatAddress, formatHumanName } from './fhir-ext.js';

// AUTOGENERATED -- DO NOT EDIT
var _Fhir_instances;
class Fhir extends SDKResource {
    constructor(config) {
        super(config);
        _Fhir_instances.add(this);
        /**
         * Performs a FHIR search and returns the results as a Bundle resource
         * @param options FHIR resource type and FHIR search parameters
         * @param request optional OystehrClientRequest object
         * @returns FHIR Bundle resource
         */
        this.search = search;
        this.create = create;
        this.get = get;
        this.update = update;
        this.patch = patch;
        this.delete = del;
        this.history = history;
        this.batch = batch;
        this.transaction = transaction;
        this.formatAddress = formatAddress;
        this.formatHumanName = formatHumanName;
    }
}
_Fhir_instances = new WeakSet();

export { Fhir };
//# sourceMappingURL=fhir.js.map
